var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _path, _path2, _path3, _path4, _path5, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _path6, _path7, _path8, _path9, _path10, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _path11, _path12, _path13, _rect38, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrinciplesD(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 737,
    height: 92,
    viewBox: "0 0 737 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 276.861,
    y: 45.9697,
    width: 46.1537,
    height: 45.9693,
    transform: "rotate(180 276.861 45.9697)",
    fill: "#F4EEE7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 230.709,
    y: 45.9697,
    width: 46.1537,
    height: 45.9693,
    transform: "rotate(180 230.709 45.9697)",
    fill: "#3098F3"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 369.17,
    y: 45.9697,
    width: 46.1537,
    height: 45.9693,
    transform: "rotate(180 369.17 45.9697)",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 323.018,
    y: 45.9697,
    width: 46.1537,
    height: 45.9693,
    transform: "rotate(180 323.018 45.9697)",
    fill: "#082C4E"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 276.861,
    y: 91.9375,
    width: 46.1537,
    height: 45.9693,
    transform: "rotate(180 276.861 91.9375)",
    fill: "#FE6571"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 230.709,
    y: 91.9375,
    width: 46.1537,
    height: 45.9693,
    transform: "rotate(180 230.709 91.9375)",
    fill: "#082C4E"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 369.17,
    y: 91.9375,
    width: 46.1537,
    height: 45.9693,
    transform: "rotate(180 369.17 91.9375)",
    fill: "#FFCC00"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 323.018,
    y: 91.9375,
    width: 46.1537,
    height: 45.9693,
    transform: "rotate(180 323.018 91.9375)",
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 415.326,
    y: 91.9375,
    width: 46.1537,
    height: 45.9693,
    transform: "rotate(180 415.326 91.9375)",
    fill: "#F9F5F1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M276.891 46.0301V0C264.145 0 253.783 10.3203 253.783 23.0151C253.783 35.7098 264.145 46.0301 276.891 46.0301Z",
    fill: "#3098F3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M276.861 0V46.0301C289.607 46.0301 299.969 35.7098 299.969 23.0151C299.969 10.3203 289.607 0 276.861 0Z",
    fill: "#F2EAE2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M369.17 46.0014L382.376 46.0118C382.376 46.0118 382.376 46.0118 382.376 46.0014C382.376 40.5653 386.819 36.1393 392.277 36.1393C397.735 36.1393 402.179 40.5653 402.179 46.0014C402.179 46.0014 402.179 46.0014 402.179 46.0118L415.385 46.0118C415.385 46.0118 415.385 46.0118 415.385 46.0014C415.385 33.3067 405.023 22.9863 392.277 22.9863C379.532 22.9863 369.17 33.3067 369.17 46.0014Z",
    fill: "#FFCC00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M415.355 91.9999L415.366 78.8469C415.366 78.8469 415.366 78.8469 415.355 78.8469C409.897 78.8469 405.454 74.4209 405.454 68.9848C405.454 63.5487 409.897 59.1227 415.355 59.1227C415.355 59.1227 415.355 59.1227 415.366 59.1227V45.9697C415.366 45.9697 415.366 45.9697 415.355 45.9697C402.61 45.9697 392.248 56.2901 392.248 68.9848C392.248 81.6795 402.61 91.9999 415.355 91.9999Z",
    fill: "#3098F3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M184.557 45.9697V91.9999C197.302 91.9999 207.664 81.6795 207.664 68.9848C207.664 56.2901 197.302 45.9697 184.557 45.9697Z",
    fill: "#F2EAE2"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 461.537,
    y: 46.0293,
    width: 46.1537,
    height: 45.9693,
    transform: "rotate(-180 461.537 46.0293)",
    fill: "white"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 600.002,
    y: 46.0293,
    width: 46.1537,
    height: 45.9693,
    transform: "rotate(-180 600.002 46.0293)",
    fill: "#FFCC00"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 600.002,
    y: 46.0293,
    width: 46.1537,
    height: 45.9693,
    transform: "rotate(-180 600.002 46.0293)",
    fill: "#FFCC00"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 646.158,
    y: 46.0293,
    width: 46.1537,
    height: 45.9693,
    transform: "rotate(-180 646.158 46.0293)",
    fill: "#3098F3"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 692.158,
    y: 46.0293,
    width: 46.1537,
    height: 45.9693,
    transform: "rotate(-180 692.158 46.0293)",
    fill: "white"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 736.002,
    y: 46,
    width: 44,
    height: 46,
    transform: "rotate(-180 736.002 46)",
    fill: "#FFCC00"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 553.846,
    y: 46.0293,
    width: 46.1537,
    height: 45.9693,
    transform: "rotate(-180 553.846 46.0293)",
    fill: "#082C4E"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 553.846,
    y: 46.0293,
    width: 46.1537,
    height: 45.9693,
    transform: "rotate(-180 553.846 46.0293)",
    fill: "#082C4E"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 461.537,
    y: 91.999,
    width: 46.1537,
    height: 45.9693,
    transform: "rotate(-180 461.537 91.999)",
    fill: "#082C4E"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 461.537,
    y: 91.999,
    width: 46.1537,
    height: 45.9693,
    transform: "rotate(-180 461.537 91.999)",
    fill: "#082C4E"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 507.693,
    y: 46.0293,
    width: 46.1537,
    height: 45.9693,
    transform: "rotate(-180 507.693 46.0293)",
    fill: "#FE6571"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 600.002,
    y: 91.999,
    width: 46.1537,
    height: 45.9693,
    transform: "rotate(-180 600.002 91.999)",
    fill: "white"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 646.158,
    y: 91.999,
    width: 46.1537,
    height: 45.9693,
    transform: "rotate(-180 646.158 91.999)",
    fill: "#FE6571"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 692.158,
    y: 91.999,
    width: 46.1537,
    height: 45.9693,
    transform: "rotate(-180 692.158 91.999)",
    fill: "#082C4E"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 736.002,
    y: 92,
    width: 44,
    height: 46,
    transform: "rotate(-180 736.002 92)",
    fill: "white"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 507.693,
    y: 91.999,
    width: 46.1537,
    height: 45.9693,
    transform: "rotate(-180 507.693 91.999)",
    fill: "white"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.75,
    x: 553.846,
    y: 91.999,
    width: 46.1537,
    height: 45.9693,
    transform: "rotate(-180 553.846 91.999)",
    fill: "#F9F5F1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M553.835 91.999L553.846 78.8461C553.846 78.8461 553.846 78.8461 553.835 78.8461C548.377 78.8461 543.934 74.4201 543.934 68.984C543.934 63.5478 548.377 59.1218 553.835 59.1218C553.835 59.1218 553.835 59.1218 553.846 59.1218L553.846 45.9689C553.846 45.9689 553.846 45.9689 553.835 45.9689C541.09 45.9689 530.728 56.2892 530.728 68.984C530.728 81.6787 541.09 91.999 553.835 91.999Z",
    fill: "#082C4E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M736.107 91.999L736.117 78.8461C736.117 78.8461 736.117 78.8461 736.107 78.8461C730.649 78.8461 726.205 74.4201 726.205 68.984C726.205 63.5478 730.649 59.1218 736.107 59.1218C736.107 59.1218 736.107 59.1218 736.117 59.1218L736.117 45.9689C736.117 45.9689 736.117 45.9689 736.107 45.9689C723.361 45.9689 712.999 56.2892 712.999 68.984C712.999 81.6787 723.361 91.999 736.107 91.999Z",
    fill: "#082C4E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M600.002 46L553.787 46C553.787 58.6947 564.149 69.0151 576.895 69.0151C589.64 69.0151 600.002 58.6947 600.002 46Z",
    fill: "#3098F3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M692.217 0L646.002 -2.01204e-06C646.002 12.6947 656.364 23.0151 669.109 23.0151C681.855 23.0151 692.217 12.6947 692.217 0Z",
    fill: "#FE6571"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M599.998 0.0298599L586.792 0.0194459C586.792 0.0194459 586.792 0.019444 586.792 0.0298581C586.792 5.466 582.349 9.89197 576.891 9.89197C571.433 9.89197 566.989 5.46599 566.989 0.0298555C566.989 0.0298555 566.989 0.0298575 566.989 0.0194433L553.783 0.0194416C553.783 0.0194416 553.783 0.0194397 553.783 0.0298538C553.783 12.7246 564.145 23.0449 576.891 23.0449C589.636 23.0449 599.998 12.7246 599.998 0.0298599Z",
    fill: "white"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 46.1543,
    y: 46.0303,
    width: 46.1537,
    height: 45.9693,
    transform: "rotate(-180 46.1543 46.0303)",
    fill: "#FE6571"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 184.615,
    y: 46.0303,
    width: 46.1537,
    height: 45.9693,
    transform: "rotate(-180 184.615 46.0303)",
    fill: "#FFCC00"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 184.615,
    y: 46.0303,
    width: 46.1537,
    height: 45.9693,
    transform: "rotate(-180 184.615 46.0303)",
    fill: "#FFCC00"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 138.463,
    y: 46.0303,
    width: 46.1537,
    height: 45.9693,
    transform: "rotate(-180 138.463 46.0303)",
    fill: "#082C4E"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 138.463,
    y: 46.0303,
    width: 46.1537,
    height: 45.9693,
    transform: "rotate(-180 138.463 46.0303)",
    fill: "#082C4E"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 92.1543,
    y: 46.0303,
    width: 46.1537,
    height: 45.9693,
    transform: "rotate(-180 92.1543 46.0303)",
    fill: "#F2EAE2"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 46.1543,
    y: 91.999,
    width: 46.1537,
    height: 45.9693,
    transform: "rotate(-180 46.1543 91.999)",
    fill: "#082C4E"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 46.1543,
    y: 91.999,
    width: 46.1537,
    height: 45.9693,
    transform: "rotate(-180 46.1543 91.999)",
    fill: "#082C4E"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 184.615,
    y: 91.999,
    width: 46.1537,
    height: 45.9693,
    transform: "rotate(-180 184.615 91.999)",
    fill: "#3098F3"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 92.3105,
    y: 91.999,
    width: 46.1537,
    height: 45.9693,
    transform: "rotate(-180 92.3105 91.999)",
    fill: "white"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.75,
    x: 138.463,
    y: 91.999,
    width: 46.1537,
    height: 45.9693,
    transform: "rotate(-180 138.463 91.999)",
    fill: "#F9F5F1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M138.452 91.999L138.463 78.8461C138.463 78.8461 138.463 78.8461 138.452 78.8461C132.994 78.8461 128.551 74.4201 128.551 68.984C128.551 63.5478 132.994 59.1218 138.452 59.1218C138.452 59.1218 138.452 59.1218 138.463 59.1218L138.463 45.9689C138.463 45.9689 138.463 45.9689 138.452 45.9689C125.707 45.9689 115.345 56.2892 115.345 68.984C115.345 81.6787 125.707 91.999 138.452 91.999Z",
    fill: "#082C4E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M184.615 0.0298599L171.409 0.0194459C171.409 0.0194459 171.409 0.019444 171.409 0.0298581C171.409 5.466 166.966 9.89197 161.508 9.89197C156.05 9.89197 151.606 5.46599 151.606 0.0298555C151.606 0.0298555 151.606 0.0298575 151.606 0.0194433L138.4 0.0194416C138.4 0.0194416 138.4 0.0194397 138.4 0.0298538C138.4 12.7246 148.762 23.0449 161.508 23.0449C174.253 23.0449 184.615 12.7246 184.615 0.0298599Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M0.0142247 0.000127897L0.00381368 13.2058C0.00381368 13.2058 0.00381178 13.2058 0.0142259 13.2058C5.45036 13.2058 9.87634 17.6495 9.87634 23.1075C9.87634 28.5654 5.45037 33.0091 0.0142277 33.0091C0.0142277 33.0091 0.0142296 33.0091 0.00381544 33.0091L0.0038166 46.2148C0.0038166 46.2148 0.0038147 46.2148 0.0142288 46.2148C12.709 46.2148 23.0293 35.8531 23.0293 23.1075C23.0293 10.3618 12.709 0.000126787 0.0142247 0.000127897Z",
    fill: "white"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 369.17,
    width: 46.1537,
    height: 45.9693,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0",
    transform: "translate(0 -0.00200496) scale(0.00675676)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0",
    width: 148,
    height: 148,
    xlinkHref: "data:image/png;base64,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"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrinciplesD);
export default __webpack_public_path__ + "static/media/principles-d.d6faf583260aafb7a635bfe9120eea83.svg";
export { ForwardRef as ReactComponent };